export default {
  state: () => ({
    users: [],
  }),
};
